<template>
    <div>
        
        <!-- Filter Start -->
        <custom-filter
            :getFilterOnStart="true"
            @filterChange="changeFilter"
        ></custom-filter>
        <!-- Filter End -->

        <!-- Stats Start -->
        <div class="row mt-4 mb-4">
            <div class="col-md-4">
                <highlight-stats
                    title="No. of Bottle Scan"
                    :value="data.stats ? data.stats.total != null ? data.stats.total : 0 : 'Loading...'"
                    unit="Activities"
                ></highlight-stats>
            </div>
            <div class="col-md-4">
                <highlight-stats
                    title="No. of Verified Scan"
                    :value="data.stats ? data.stats.valid ? data.stats.valid : 0 : 'Loading...'"
                    unit="Activities"
                ></highlight-stats>
            </div>
            <div class="col-md-4">
                <highlight-stats
                    title="Suspicious Item Found"
                    :value="data.stats ? data.stats.invalid ? data.stats.invalid : 0 : 'Loading...'"
                    unit="Total Report"
                ></highlight-stats>
            </div>
        </div>
        <!-- Stats End -->

        <!-- Scan & Suspicious Item and Most Suspicious Product Start -->
        <div class="row">
            <div class="col-md-8">
                <div class="innerBox">
                    <h5 class="elegant--sub-title">Scan & Suspicious Item</h5>
                    <scan-and-suspicious-item-bar-chart
                        :data="data.scanAndSuspicious"
                        :filter="filter"
                    ></scan-and-suspicious-item-bar-chart>
                </div>
            </div>
            <div class="col-md-4">
                <div class="innerBox">
                    <h5 class="elegant--sub-title">Most Suspicious Product</h5>
                    <most-suspicious-product-pie-chart
                        :data="data.mostSuspicious"
                    ></most-suspicious-product-pie-chart>
                </div>
            </div>
        </div>
        <!-- Scan & Suspicious Item and Most Suspicious Product End -->

        <!-- Scan by Location Bar Chart Start -->
         <!-- <div class="row mt-4">
            <div class="col">
                <div class="innerBox">
                    <div class="row">
                        <div class="col-md-10">
                            <h5 class="elegant--sub-title">Scan by Location</h5>
                        </div>
                        <div class="col-md-2">
                            <MultiSelect 
                                v-model="filter.status"
                                :options="[]"
                                placeholder="Jawa Barat"
                                class="elegant-multiselect"
                                />
                        </div>
                    </div>
                    <scan-by-location-bar-chart
                    ></scan-by-location-bar-chart>
                </div>
            </div>
         </div> -->
        <!-- Scan by Location Bar Chart End -->
        
    </div>
</template>

<script>
    import qs from 'qs'
    import customFilter from '@/components/filter/customFilter'
    import highlightStats from './children/HighlightStats'

    import scanAndSuspiciousItemBarChart from './children/scanAndSuspiciousItemBarChart'
    import mostSuspiciousProductPieChart from './children/mostSuspiciousProductPieChart'
    // import scanByLocationBarChart from './children/scanByLocationBarChart.vue'

    export default {
        metaInfo : {
            title : 'Highlights'
        },
        data () {
            return {
                filter : {},
                data : {
                    stats : null,
                    scanAndSuspicious : null,
                    mostSuspicious :null,
                }
            }
        },
        components : {
            customFilter,
            highlightStats,

            scanAndSuspiciousItemBarChart,
            mostSuspiciousProductPieChart,
            // scanByLocationBarChart,
        },
        mounted () {
            // this.fetchData();
        },
        methods : {
            changeFilter (filter) {
                for (var i in filter) this.filter[i] = filter[i];
                
                this.fetchData();
            },
            fetchData () {
                //Remove filter from filter
                let filterlessFilter = JSON.parse(JSON.stringify(this.filter));
                delete filterlessFilter.filter;

                //Get Stats
                this.$http.get(`/api/highlight/overview?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.stats = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get Scan & Suspicious Item
                this.$http.get(`/api/highlight/scan-chart?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.scanAndSuspicious = resp.data.data;
                })
                .catch((err)=>{console.log(err)});

                //Get Most Suspicious Product
                this.$http.get(`/api/highlight/by-product?${qs.stringify(filterlessFilter, {skipNulls:true, arrayFormat: 'comma'})}`)
                .then((resp)=>{
                    this.data.mostSuspicious = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }
</style>